import * as React from "react";
import type { SVGProps } from "react";
const SvgLightningCircleContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.6 12a9.6 9.6 0 1 1-19.2 0 9.6 9.6 0 1 1 19.2 0Z"
    />
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 13.6 12.8 6v5.2h4L11.2 18v-4.4z"
    />
  </svg>
);
export default SvgLightningCircleContained;
